'use client';

import { atomWithStorage, StorageKey } from '@capsicum/common';
import { atom } from 'jotai';

export const showEmailOnAlmostDone = atom('');
export const showFavoriteTeamDrawer = atomWithStorage<boolean>(StorageKey.ShowSelectYourFavTeam, true);
export const isRegisteredSuccessAtom = atom<boolean>(false);
export const onboardingShownAtom = atomWithStorage<boolean>(StorageKey.OnboardingShown, false);
export const showEmailInputFormAtom = atom<boolean>(true);
